"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SingleChoiceQuestionRenderer = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const material_1 = require("@mui/material");
const answer_1 = require("../model/answer");
exports.SingleChoiceQuestionRenderer = (0, react_1.memo)(({ question, onAnswerChange, sx, userAnswerState, }) => {
    const theme = (0, material_1.useTheme)();
    const handleChange = (0, react_1.useCallback)((value) => {
        onAnswerChange === null || onAnswerChange === void 0 ? void 0 : onAnswerChange(value);
    }, [onAnswerChange]);
    const selectOptionColor = (0, react_1.useMemo)(() => {
        if (!userAnswerState) {
            return theme.palette.primary.main;
        }
        const { state } = userAnswerState;
        return state === answer_1.AnswerResultState.Correct
            ? theme.palette.success.main
            : state === answer_1.AnswerResultState.Incorrect
                ? theme.palette.error.main
                : theme.palette.primary.main;
    }, [
        userAnswerState,
        theme.palette.success.main,
        theme.palette.error.main,
        theme.palette.primary.main,
    ]);
    return ((0, jsx_runtime_1.jsx)(material_1.Stack, { direction: "column", spacing: 1, sx: sx, children: question.options.map((option) => ((0, jsx_runtime_1.jsxs)(material_1.Stack, { direction: "row", alignItems: "center", spacing: 1, onClick: () => {
                handleChange(option.value);
            }, children: [(0, jsx_runtime_1.jsx)(material_1.Radio, { value: option.value, checked: (userAnswerState === null || userAnswerState === void 0 ? void 0 : userAnswerState.answer) === option.value, sx: {
                        color: theme.palette.text.primary,
                        "&.Mui-checked": {
                            color: selectOptionColor,
                        },
                    } }), (0, jsx_runtime_1.jsx)(material_1.Typography, { variant: "body1", color: (userAnswerState === null || userAnswerState === void 0 ? void 0 : userAnswerState.answer) === option.value
                        ? selectOptionColor
                        : theme.palette.text.primary, children: option.displayText })] }, option.value))) }));
});
exports.SingleChoiceQuestionRenderer.displayName = "SingleChoiceQuestionRenderer";
